<template>
  <div class="exchange-bg" @click.stop v-if="data.propType === 'coupon'">
    <div class="title">兑换成功</div>
    <img class="close" src="~/assets/imgs/detail_close.png" alt="" @click="close" />
    <div class="coupon">
      <div class="left">
        <div class="price" v-if="data.couponType == 1">
          ￥<span>{{ data.couponDeductionAmount / 100 }}</span>
        </div>
        <div class="price" v-if="data.couponType == 2">
          <span>{{ data.couponDiscount }}</span
          >折
        </div>
        <div class="use">满{{ data.couponLimitAmount / 100 }}元可用</div>
      </div>
      <div class="right">
        <div class="title">
          {{
            data.couponType === "1"
              ? data.couponDeductionAmount / 100 + "元"
              : data.couponDiscount + "折"
          }}优惠券<span v-if="data.num > 1">x{{ data.num }}</span>
        </div>
        <div class="date">
          有效期至
          {{
            data.validEndTime === -1
              ? "永久"
              : new Date(data.validEndTime).toLocaleDateString("zh").replace(/\//g, "-")
          }}
        </div>
      </div>
    </div>
    <div class="mobile-toast-desc" v-if="detail.paymentType === 'mobile_integral'">
      <p>
        <span>订单编号：</span><span>{{ mobileOrderNo }}</span>
      </p>
      <p>
        <span>支付积分：</span><span>{{ detail.price && detail.price * exchangeCount }}</span>
      </p>
      <p>
        <span>支付账号：</span><span>{{ cmccMobile }}</span>
      </p>
    </div>
    <p class="success-desc">兑换成功，可在“商城-我的-我的优惠券”页面查询</p>
    <div class="toast-btn" @click="close">确定</div>
  </div>
  <div class="exchange-bg" @click.stop v-else-if="data.propType === 'cdkey'">
    <div class="title">兑换成功</div>
    <img class="close" src="~/assets/imgs/detail_close.png" alt="" @click="close" />
<!--    <div class="changenum" v-if="data.num > 1">-->
    <div class="changenum" >
      兑换码：<span class="codevalue">{{
        data.orderValues?.length > 0 ? data.orderValues[0] : ""
      }}</span>
    </div>
<!--    <img v-if="data.num > 1" class="changenum-icon" :src="data.iconUrl" alt="" />-->
    <p v-if="data.num > 1" class="changenum-text">
      兑换码道具 <span>×{{ data.num }}</span>
    </p>
    <div class="mobile-toast-desc" v-if="detail.paymentType === 'mobile_integral'">
      <p>
        <span>订单编号：</span><span>{{ mobileOrderNo }}</span>
      </p>
      <p>
        <span>支付积分：</span><span>{{ detail.price && detail.price * exchangeCount }}</span>
      </p>
      <p>
        <span>支付账号：</span><span>{{ cmccMobile }}</span>
      </p>
    </div>
    <p class="success-desc">{{detail.gameId ? '请复制兑换码后，进入游戏使用':'兑换成功，可在"商城-我的-我的礼包"页面查询'}}</p>
<!--    <div class="toast-btn" v-if="data.num > 1" @click="close">确定</div>-->
    <div class="btn-list">
      <div class="toast-btn cdkey-btn copy-btn" @click="copycode">复制兑换码</div>
      <div class="toast-btn cdkey-btn" @click="toGame(detail.gameId)" v-if="detail.gameId">进入游戏</div>
      <div class="toast-btn cdkey-btn no-game" v-else>未关联游戏</div>
    </div>


  </div>
  <div class="exchange-bg" @click.stop v-else>
    <div class="title">兑换成功</div>
    <img class="close" src="~/assets/imgs/detail_close.png" alt="" @click="close" />
    <img class="changenum-icon" :src="data.iconUrl" alt="" />
    <p class="changenum-text">
      {{ data.title }} <span v-if="data.num > 1">×{{ data.num }}</span>
    </p>
    <div class="mobile-toast-desc" v-if="detail.paymentType === 'mobile_integral'">
      <p>
        <span>订单编号：</span><span>{{ mobileOrderNo }}</span>
      </p>
      <p>
        <span>支付积分：</span><span>{{ detail.price && detail.price * exchangeCount }}</span>
      </p>
      <p>
        <span>支付账号：</span><span>{{ cmccMobile }}</span>
      </p>
    </div>
    <p class="success-desc">兑换成功，可在“商城-我的-我的礼包”页面查询</p>
    <div class="toast-btn" @click="close">确定</div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";
import { copyText } from "~/utils/jsb";
import { pandora } from "~/utils/index";
import { showToast } from "vant";
import { getContentGameInfo } from "@@/alova";
import { isEmptyString } from "@metaapp/utils";

const emit = defineEmits(["close"]);
const props = defineProps<{
  data: {};
  detail: {};
  exchangeCount: number;
}>();
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = () => {
  emit("close");
};
/**
 * @description 复制兑换码
 * @return {void}
 */
const copycode = () => {
  copyText(props.data?.orderValues?.[0]);
  showToast("复制成功，快进入游戏兑换礼包吧~");
  // close();
};

/**
 * @description 拉起游戏
 * @param {string} gameId 游戏Id
 * @return {void}
 */
const toGame = async (gameId)=>{
  if(!isEmptyString(gameId)){
    if (!(await isGameInstall(gameId))) {
      jsb?.execAsyncV2("goDetail", gameId);
    }else{
      const data = await getContentGameInfo({ id: gameId });
      jsb?.execAsyncV2("playGame", JSON.stringify(data));
    }
  }
}
onMounted(() => {
  pandora("event_goods_shop_detail_exchange_result", "福利商店商品兑换结果", {
    merchandise_id: sessionStorage.getItem("commodityId") || "",
    merchandise_name: props.detail.name,
    status: props.detail.status,
    exchange_type: props.detail.paymentType,
    reason: "成功",
    goods_type: props.detail.propType,
    result: "success",
    exchange_num: props.exchangeCount,
    exchange_cost: props.detail.price ? props.detail.price * (props.exchangeCount || 1) : 0
  });
});
</script>
<style scoped lang="scss">
.exchange-bg {
  width: 13.25rem;
  background: #fff;
  position: absolute;
  border-radius: 0.5rem;

  .title {
    font-size: 0.68rem;
    font-weight: 600;
    text-align: center;
    margin: 0.93rem 0 0.51rem 0;
  }

  .changenum {
    font-size: 0.68rem;
  }

  .close {
    height: 0.85rem;
    width: 0.85rem;
    position: absolute;
    top: 0.93rem;
    right: 0.8rem;
  }
}

.coupon {
  width: 11.52rem;
  height: 3.2rem;
  background: #fff5ec;
  border-radius: 0.2rem;
  margin: 0.85rem calc((13.25rem - 11.52rem) / 2);
  padding: 0.426rem 0.32rem 0;
  box-sizing: border-box;
}

.coupon .left {
  width: 3.84rem;
  height: 2.34rem;
  background: url("~/business/assets/imgs/coupon_icon.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.426rem;
  line-height: 0.597rem;
  color: #fff;
  float: left;
}

.coupon .left .price {
  font-size: 0.47rem;
  line-height: 0.66rem;
}

.coupon .left .price span {
  font-size: 0.938rem;
  font-weight: 600;
}

.coupon .right {
  float: left;
  font-size: 0.47rem;
  line-height: 0.66rem;
  color: #888888;
  margin-left: 0.34rem;
}

.coupon .right img {
  width: 0.512rem;
  height: 0.426rem;
  margin-right: 0.085rem;
}

.coupon .right .title {
  margin: 0;
  font-size: 0.64rem;
  line-height: 0.89rem;
  color: #333333;
  text-align: start;
}

.mobile-toast-desc {
  margin-top: 0.34rem;
}

.mobile-toast-desc p {
  display: flex;
  justify-content: space-between;
  padding: 0 2.13rem;
  line-height: 0.725rem;
  margin-bottom: 0.34rem;
  box-sizing: border-box;
  font-size: 0.512rem;
}

.mobile-toast-desc p span:nth-child(1) {
  color: #666666;
}

.success-desc {
  font-size: 0.512rem;
  color: #999999;
  width: 100%;
  text-align: center;
  margin-bottom: 0.554rem;
}

.toast-btn {
  padding: 0.38rem 1.28rem;
  box-sizing: border-box;
  color: #fff;
  background: #ff7310;
  border-radius: 0.85rem;
  width: 6.4rem;
  margin: 1.28rem auto 0.85rem;
  text-align: center;
  font-size: 0.682rem;
}
.btn-list{
  display: flex;
  margin: -1rem auto 0.35rem;
}
.cdkey-btn{
  padding: 0.38rem 0.3rem;
  width: 5rem;
}
.copy-btn{
  background-color: white;
  border: 1px #ff7310 solid;
  color: #ff7310;
}
.no-game{
  background-color: #999;
}
.changenum {
  width: 11.52rem;
  height: 2.56rem;
  background: #f5f5f5;
  border-radius: 0.426rem;
  margin: 0.512rem auto 0.554rem;
  line-height: 2.56rem;
  text-align: center;
  // overflow: hidden;
}

.changenum span {
  color: #ff7310;
}

.changenum-icon {
  width: 4.1rem;
  height: 2.56rem;
  border-radius: 0.34rem;
  margin: 0 auto;
  display: block;
}

.changenum-text {
  font-size: 0.6rem;
  color: #333333;
  margin-top: 0.256rem;
  margin-bottom: 0.37rem;
  width: 100%;
  text-align: center;
}

.changenum-text span {
  color: #ff7210;
  font-weight: 500;
}
</style>
